export default [
    'Invoicing', 'Client Settings', 'Branding'
]